import { type Node, type NodeProps } from '@xyflow/react';
import { Alert, Drawer, type DrawerProps } from 'antd';
import useCommonNodeHandles from 'automations/hooks/useCommonNodeHandles';
import { canEditContentSelector } from 'automations/selectors/reactFlow';
import { useSelector } from 'react-redux';

import styles from './NodeMenu.module.scss';

export default function NodeMenu({
  node,
  children,
  drawerProps,
  canOpen = true,
  extraLarge = true,
  withContainerLayout = true,
}: {
  node: NodeProps<Node<any>>;
  children: React.ReactNode;
  drawerProps?: DrawerProps;
  canOpen?: boolean;
  extraLarge?: boolean;
  withContainerLayout?: boolean;
}) {
  const { open, setMenuOpen } = useCommonNodeHandles(node);
  const canEditContent = useSelector(canEditContentSelector(node.id));

  return (
    <Drawer
      open={open && canOpen}
      onClose={() => setMenuOpen(false)}
      placement="bottom"
      size="large"
      height={extraLarge ? '80vh' : undefined}
      {...drawerProps}
    >
      {withContainerLayout ? (
        <div className={styles.container}>
          {!canEditContent && (
            <Alert showIcon type="info" message="You are current in view only mode, No changes are allowed" />
          )}
          {children}
        </div>
      ) : children}
    </Drawer>
  );
}
